import React from 'react';

// Minimal base; inputs are themed globally via index.css (input selectors)
const baseClasses = 'brand-input';

export const Input = React.forwardRef(function Input({ className = '', type = 'text', ...props }, ref) {
  const classes = [baseClasses, className].filter(Boolean).join(' ');
  return <input ref={ref} className={classes} type={type} {...props} />;
});

Input.displayName = 'Input';

export default Input;
